import React, { useEffect, useReducer } from 'react';
import cn from 'classnames';

// REDUX
import { useAppDispatch, useAppSelector } from '@Managers/Redux/Hooks';
import { getFixesState, setFixesState } from '@Managers/Redux/AppState/AppState';

// STYLES
import styles from '../Fixes.scss';
import FixesCombinationsButton from './Fixes.CombinationsButton';

const FixesCombinations: React.FC<{}> = ({}) => {
    const [state, setState] = useReducer((state: {}, newState: {}) => ({ ...state, ...newState }), {});

    const dispatch = useAppDispatch();
    const fixesState = useAppSelector(getFixesState);

    function toggleActive() {
        dispatch(setFixesState({ active: !fixesState.active, currentIndex: undefined }));
    }

    function clearCombinations() {
        dispatch(setFixesState({ fixCombinations: [] }));
    }

    useEffect(() => {
        if (fixesState.fixCombinations.length > 0 && !fixesState.active) {
            dispatch(setFixesState({ active: true, currentIndex: undefined }));
        }
    }, [fixesState.fixCombinations]);

    return (
        <>
            <div className={styles.fix_group}>
                <div className={styles.fix_group_header}>
                    Fix order:
                    {fixesState.fixCombinations.length > 0 && (
                        <>
                            <button
                                className={cn(styles.fix_combination_toggle, fixesState.active ? styles.enabled : styles.disabled)}
                                onClick={() => toggleActive()}
                            >
                                {fixesState.active ? 'ENABLED' : 'DISABLED'}
                            </button>

                            <button className={styles.fix_combination_clear} onClick={() => clearCombinations()}>
                                Clear
                            </button>
                        </>
                    )}
                </div>
                <div className={styles.fix_combinations_list}>
                    {fixesState.fixCombinations.map((element, index) => (
                        <FixesCombinationsButton key={index} index={index} option={element} />
                    ))}
                </div>
            </div>
        </>
    );
};

export default FixesCombinations;
